"use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _View = _interopRequireDefault(require("../../exports/View"));
var _react = _interopRequireDefault(require("react"));
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Common implementation for a simple stubbed view.
 */ var UnimplementedView = /*#__PURE__*/ function(_react_default_Component) {
    _inherits(UnimplementedView, _react_default_Component);
    var _super = _create_super(UnimplementedView);
    function UnimplementedView() {
        _class_call_check(this, UnimplementedView);
        return _super.apply(this, arguments);
    }
    _create_class(UnimplementedView, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _react.default.createElement(_View.default, {
                    style: [
                        unimplementedViewStyles,
                        this.props.style
                    ]
                }, this.props.children);
            }
        }
    ]);
    return UnimplementedView;
}(_react.default.Component);
var unimplementedViewStyles = process.env.NODE_ENV !== "production" ? {
    alignSelf: "flex-start",
    borderColor: "red",
    borderWidth: 1
} : {};
var _default = UnimplementedView;
exports.default = _default;
module.exports = exports.default;
